export enum ECaseProcessTypes {
  RENEWAL = 'c6a0689e-0dd3-43e1-84fe-afa7b8506b4f',
  APPLICATION = '7f4a6d51-3bb7-4d9e-9e2a-1c0b5d8a9e72',
  VARIATION = '04377361-ecdb-4ab7-9d11-8f5372237ae4',
  OTHER_REQUEST = '64ef0a97-740d-4ddd-ae38-c3d4f2b43b56',
}
